import { isArray, size } from 'lodash-es'

/**
 * Checks if an array has any elements
 * @param array - The array to check
 * @returns true if the array exists, is an array, and has at least one element
 */
const any = (array: unknown[]): boolean => isArray(array) && size(array) > 0

export default any
